import React from 'react';
import { BlockBody } from '@tradingblock/components';
import { BlockType } from '@tradingblock/types';
import { getBlockProps } from '../../../utilities/block';
import { AdminCashieringHeader } from './AdminCashieringHeader';
import { Block } from '../../../components/blocks/Block';
import { AdminCashieringIndex } from './AdminCashieringIndex';

export const AdminCashieringContentBlock: React.FunctionComponent<{}> = () => {
  return (
    <BlockBody>
      <AdminCashieringIndex />
    </BlockBody>
  );
};

export const AdminCashieringBlock: React.FunctionComponent<{}> = () => {
  return (
    <Block
      {...getBlockProps(BlockType.AdminCashiering, <AdminCashieringHeader blockType={BlockType.AdminCashiering} />)}
    >
      <AdminCashieringContentBlock />
    </Block>
  );
};
